import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "text-primary fw-normal border border-lightgray border-top-0 border-start-0 border-end-0 pb-3 my-5" }, " Clickable Image: ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-secondary" }, "Preview Image:", -1)
const _hoisted_4 = { class: "col-12 bg-light border border-lightgray rounded-4 p-3 bg-pink" }
const _hoisted_5 = { class: "drag-image border-primary border text-primary d-flex flex-column align-items-center justify-content-center" }
const _hoisted_6 = { class: "border border-lightgray border-bottom-0 border-start-0 border-end-0 mt-5 pt-4 row mx-auto" }
const _hoisted_7 = { class: "col-12 col-sm d-flex justify-content-end px-0" }
const _hoisted_8 = {
  class: "btn btn-primary text-light rounded-pill py-1",
  type: "submit"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-check",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "fa fa-spinner fa-spin",
  "aria-hidden": "true"
}

import router from "@/router";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";
import { toast } from "vue3-toastify";
import { onMounted, reactive, ref } from "vue";
import { handleImages } from "@/composable/useHandleImages";
import { useProjectStimuliStore } from "@/store/ProjectStimuliStore";
import RangeSlider from "@/components/base-components/RangeSlider.vue";
import UploadImages from "vue-upload-drop-images/dist/vue-upload-drop-images.vue";
import BaseInputUnderline from "@/components/base-components/BaseInputUnderline.vue";


const __default__ = {
  name: "ClickableImageStimuli",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  stimuliUUID: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const ProjectStimuliStore = useProjectStimuliStore();
const { project } = storeToRefs(ProjectStimuliStore);
const { addStimuli, updateStimuli, getStimul } = ProjectStimuliStore;
const route = useRoute();
const imageSrc = ref();
const loading = ref(false);
let form = reactive({
  id: "",
  name: "Clickable Image Stimuli",
  type: "clickable",
  question: "",
  requiredClicks: 1,
  order: 0,
  imgSrc: "",
});

onMounted(async () => {
  if (route.name === "CreateStimuli") return;

  const stimul = getStimul(route.params.stimulId);

  if (stimul.type !== "clickable") return;

  form.id = stimul.id;
  form.question = stimul.question;
  form.order = stimul.order;
  form.requiredClicks = stimul.requiredClicks;
  form.name = stimul.name;
  imageSrc.value = stimul.imgSrc;
});

const save = async () => {
  try {
    loading.value = true;
    form.imgSrc = imageSrc.value;
    if (route.name === "EditStimuli") {
      updateStimuli(form);
      toast.success("Image stimuli was updated successfully!");
    } else {
      let current;
      form.id = props.stimuliUUID;
      project.value?.stimuli === undefined
        ? (current = 0)
        : (current = project.value.stimuli.length);
      form.order = current + 1;
      addStimuli(form);
      toast.success("Image stimuli was created successfully!");
    }
  } catch (e) {
    toast.error("Creation of clickable image stimuli has failed!");
  } finally {
    loading.value = false;
  }
  await router.push("/projects/create");
};

const callHandleImages = (files: Array<File>) => {
  handleImages(project.value?.id, props.stimuliUUID, files);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(save, ["prevent"]),
    role: "form",
    class: "pb-5 ui form"
  }, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(UploadImages, {
          class: "border border-0 py-5 bg-pink",
          max: 1,
          "max-error": "You cannot upload more then one image",
          onChanged: callHandleImages
        })
      ])
    ]),
    _createVNode(BaseInputUnderline, {
      class: "my-5 col-12 col-sm-9 col-md-6",
      value: _unref(form).question,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).question) = $event)),
      name: "clickable-image-question",
      type: "text",
      id: "clickable-image-question",
      "aria-placeholder": "What do you think?",
      placeholder: "What do you think?",
      label: "Write a question",
      required: ""
    }, null, 8, ["value"]),
    _createVNode(RangeSlider, {
      value: _unref(form).requiredClicks,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).requiredClicks) = $event)),
      min: "1",
      max: "5",
      unit: "clicks",
      label: "Clicks",
      id: "clicksFaderClickableImage"
    }, null, 8, ["value"]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", _hoisted_8, [
          _createTextVNode(" Save "),
          _hoisted_9,
          (loading.value)
            ? (_openBlock(), _createElementBlock("i", _hoisted_10))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 40, _hoisted_1))
}
}

})